import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Card } from '@percent/hosted-validation-form/ui';
import { HostedFormStep } from '../../HostedForm.types';
import { useValidationStepData } from '../../validationStepContext/useValidationStepData/useValidationStepData';
import { Flex, FormField, TextInput } from '@percent/lemonade';
import { useProgress } from '@percent/hosted-validation-form/hooks';

type FormFieldValues = {
  addressLine1: string;
  addressLine2: string;
  state: string;
  city: string;
  postal: string;
};

export const OrganisationAddress = () => {
  const { handleNext, handleBack } = useValidationStepData();
  const {
    setValue,
    formState: { errors },
    register,
  } = useFormContext<FormFieldValues>();
  const { t } = useTranslation();
  const { progress } = useProgress();

  const handleNavigateNext = () => handleNext(HostedFormStep.WEBSITE);

  const handleNavigateBack = () => {
    setValue('addressLine1', '');
    setValue('addressLine2', '');
    setValue('state', '');
    setValue('city', '');
    setValue('postal', '');
    handleBack();
  };

  return (
    <Card
      onBack={handleNavigateBack}
      title={t('hostedValidation.title.physicalAddress')}
      progress={progress}
      onNext={handleNavigateNext}
      nextButtonLabel={t('hostedValidation.button.next')}
      nextButtonDisabled={Object.keys(errors).length > 0}
    >
      <Flex direction="column" gap={16} w="100%">
        <FormField
          label={t('hostedValidation.label.address')}
          status={errors.addressLine1?.message ? 'danger' : 'default'}
          statusMessage={errors.addressLine1?.message}
        >
          <TextInput {...register('addressLine1')} placeholder={t('hostedValidation.placeholder.address')} />
        </FormField>
        <FormField
          label={t('hostedValidation.label.unit')}
          status={errors.addressLine2?.message ? 'danger' : 'default'}
          statusMessage={errors.addressLine2?.message}
        >
          <TextInput {...register('addressLine2')} placeholder={t('hostedValidation.placeholder.unit')} />
        </FormField>
        <FormField
          label={t('hostedValidation.label.state')}
          status={errors.state?.message ? 'danger' : 'default'}
          statusMessage={errors.state?.message}
        >
          <TextInput {...register('state')} placeholder={t('hostedValidation.placeholder.state')} />
        </FormField>
        <FormField
          label={t('hostedValidation.label.city')}
          status={errors.city?.message ? 'danger' : 'default'}
          statusMessage={errors.city?.message}
        >
          <TextInput {...register('city')} placeholder={t('hostedValidation.placeholder.city')} />
        </FormField>
        <FormField
          label={t('hostedValidation.label.postal')}
          status={errors.postal?.message ? 'danger' : 'default'}
          statusMessage={errors.postal?.message}
        >
          <TextInput {...register('postal')} placeholder={t('hostedValidation.placeholder.postal')} />
        </FormField>
      </Flex>
    </Card>
  );
};
